<template>

  <b-modal 
    id="survey-modal"
    modal-class='form form-challenge'
    modal-footer="hide"
    scrollable
    centered
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    :title="theTitle"
    >
     
    <div class="form form__addChallenge">
        <b-form class="m-4">
          <b-form-group
              id="input-group-2"
              label-for="participated"
              class="pb-4">
            <label>Je participe à la convention du <span class="text-primary">26 au 28 janvier 2022</span> ?</label>
            <div class="btnGroup survey" id="participated">
              <b-button class="btn-modal oui" :data-value="'OUI'" @click="toggleButtons">OUI</b-button>
              <b-button class="btn-modal non" :data-value="'NON'" @click="toggleButtons">NON</b-button>
            </div>
          </b-form-group>

          <b-form-group v-if="showAllergie"
              id="input-group-1"
              :label="'Allergies ? (Si aucune merci d\'indiquer RAS)'"
              label-for="other">
              <b-form-input
                id="other"
                v-model="form.other"
                required
                :placeholder="'Allergies'"
              ></b-form-input>
            </b-form-group>
         </b-form>
      </div>

      <template v-slot:modal-footer>
        <div class="col-12 text-right">
          <b-button
              @click="sendSurvey()"
              class="btn-challenges"
              :disabled="!isDisable()">
            {{btAdd}}
          </b-button>
        </div>
      </template>

  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import ApiService from '../../../services/ApiService'

export default {
  name: "SurveyModal",
  components: {
  },
  data() {
    return {
      theTitle:'Convention nationale 2022 de l\'inspection commerciale',
        form: {
          other: null,
          participated: null,
        },
        btAdd:'Valider',
        isLoading:true,
        showAllergie:false,
    }
  },

  computed: {
    ...mapGetters([
        'getGeneral',
        'getChallengeUpdated'
    ]),
  },
  created (){
    this.formContent = this.getGeneral;
  },
  methods:{
      onSubmit(evt) {
        evt.preventDefault()
      },

      //AFFICHAGE DU TOAST
      makeToast(variant = null) {
        if(variant == 'success'){
          this.$bvToast.toast('Vos réponses ont été envoyées', {
            title: `Réponse du sondage`,
            variant: variant,
            solid: true,
            toaster:'b-toaster-top-center'
          })  
        } else if(variant == 'error') {
          this.$bvToast.toast('Une erreur est survenu, veuillez ré-essayer.', {
            title: `Réponse du sondage`,
            variant: variant,
            solid: true,
            toaster: 'b-toaster-top-center'
          })
        }
      },

      onReset() {
        // Reset our form values
        this.form.other = null;
        this.form.participated = null;
      },

      //CLOSE THE POPUP
      closeMe(){
        this.$root.$emit('bv::hide::modal', 'survey-modal');
      }, 

      //event @click to add new challenge
      async sendSurvey(){
        if(this.form.participated !== null && this.form.other !== null){
          this.showMe = true;
          await ApiService.getSurveyApi().post(this.formatForm()).then((data) => {
            if(data.data.status !== 400){
              this.showMe = false;
              this.makeToast('success');
              this.closeMe();
            }else{
              this.makeToast('error');
            }
          }).catch(() => {
            this.makeToast('error');
          });
        }
      },

      formatForm(){
        return {
          other     : this.form.other,
          participated : this.form.participated === 'OUI',
        };
      },

      isDisable(){
        return this.form.participated !== null && this.form.other !== null;
      },

    toggleButtons(e){
      const buttons = document.querySelectorAll('.btn-modal');
      buttons ? buttons.forEach(button => button.classList.remove('select')) : '';
      e.currentTarget.classList.add('select');
      this.form.participated = e.currentTarget.getAttribute('data-value');
      if (e.currentTarget.getAttribute('data-value') === 'OUI'){
        this.showAllergie = true;
      } else {
        this.showAllergie = false;
        this.form.other = '';
      }
    },
  },
}
</script>

